<!--
 * @Description: 我要反馈 弹框
 * @Author: luchuang.wei
-->
<template>
  <xa-dialog
    :visible.sync="sentimentVisiable"
    title="舆情监控反馈"
    width="600px"
    customClass="dialog-box"
    destroy-on-close
    :before-close="() => $emit('update:sentimentVisiable', false)"
  >
    <div class="dialog-container">
      <div class="title-box">您的反馈将帮助小安持续优化舆情监控系统</div>
      <div class="main-box">
        <el-form ref="form" :model="infoData" :rules="rules" label-width="100px">
          <el-form-item label="问题类型">
            <xa-radio-group v-model="infoData.feedbackType" @change="feedbackTypeChange">
              <xa-radio label="MONITORING_DATA_IS_MISSING">监控数据丢失</xa-radio>
              <xa-radio label="OTHER">其他</xa-radio>
            </xa-radio-group>
          </el-form-item>
          <el-form-item
            :label="infoData.feedbackType == 'MONITORING_DATA_IS_MISSING' ? '缺失信息源' : '问题描述'"
            prop="content"
          >
            <xa-input
              v-model="infoData.content"
              type="textarea"
              :placeholder="
                infoData.feedbackType == 'MONITORING_DATA_IS_MISSING'
                  ? '填写您希望监控的账号、站点或链接'
                  : '留下您的建议和反馈'
              "
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="footer-box">
        <xa-button type="primary" :loading="submitLoading" @click="submit">提 交</xa-button>
      </div>
    </div>
  </xa-dialog>
</template>

<script>
export default {
  name: 'sentimentDialog',
  props: {
    sentimentVisiable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var checkContent = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error(
            this.infoData?.feedbackType === 'MONITORING_DATA_IS_MISSING' ? '请输入缺失信息源' : '请输入问题描述'
          )
        )
      } else {
        if (value.length > 500) {
          return callback(new Error('最长输入不超过500字'))
        } else {
          callback()
        }
      }
    }
    return {
      infoData: {
        feedbackType: 'MONITORING_DATA_IS_MISSING'
      },
      submitLoading: false,
      rules: {
        content: [
          {
            validator: checkContent,
            trigger: ['blur']
          }
        ]
      }
    }
  },
  watch: {
    sentimentVisiable(value) {
      if (value) {
        this.submitLoading = false
        this.infoData = {
          feedbackType: 'MONITORING_DATA_IS_MISSING',
          content: null
        }
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
    }
  },
  methods: {
    feedbackTypeChange() {
      this.infoData.content = null
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    async submit() {
      const isValid = await new Promise(resolve => {
        this.$refs.form.validate(resolve)
      })
      if (!isValid) return

      this.submitLoading = true

      const params = {
        feedbackType: this.infoData.feedbackType,
        content: this.infoData.content
      }

      this.$axios.sentiment
        .sentiment_surveillance_system(params)
        .then(res => {
          this.$xaToast({
            type: 'success',
            message: '感谢您的反馈'
          })
          this.$emit('update:sentimentVisiable', false)
        })
        .catch(err => {
          if (err.response && err.response.status == 500 && err.response.data.returnMsg) {
            this.$xaToast({ type: 'error', message: err.response.data.returnMsg })
          } else {
            this.$xaToast({ type: 'error', message: '反馈提交失败' })
          }
        })
        .finally(() => {
          this.submitLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-box {
  .dialog-container {
    .title-box {
      margin-bottom: 16px;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
    }
    .main-box {
      /deep/ .el-form {
        .el-form-item {
          margin-bottom: 12px;
        }
      }
    }
    .footer-box {
      text-align: center;
    }
  }
}
</style>
